import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IClientResponse } from 'src/app/interfaces/IClientResponse';
import { IPlantResponse } from 'src/app/interfaces/IPlantResponse';
import { IRoleResponse } from 'src/app/interfaces/IRoleResponse';
import { IUserResponse } from 'src/app/interfaces/IUserReponse';
import { UserClientDto } from 'src/app/interfaces/requests/user-client-dto';
import { UserRoleDto } from 'src/app/interfaces/requests/user-role-dto';
import { UserRoleDetailDto } from 'src/app/interfaces/requests/user-role.request';
import { IUserDetailResponse } from 'src/app/interfaces/Responses/IUserDetailResponse';
import { UserAdministrationService } from 'src/app/services/catalogs/user-administration.service';
import { LoginService } from 'src/app/services/security/login.service';

@Component({
  selector: 'neoris-user-administration',
  templateUrl: './user-administration.component.html',
  styleUrls: ['./user-administration.component.css']
})
export class UserAdministrationComponent implements OnInit {

  userList: IUserResponse[] = []
  clientList: IClientResponse[] = []
  roleList: IRoleResponse[] = []
  plantList: IPlantResponse[] = []
  zone1: boolean = true
  zone2: boolean = false
  zone3: boolean = false
  userDetailList: IUserDetailResponse
  user_name: string
  UserCatalog: UntypedFormGroup
  UserRole: UntypedFormGroup
  editUser: boolean = false
  roleListFilterSearch: IRoleResponse[];
  roleListFilterEdit: IRoleResponse[];
  roleListFilterInsert: IRoleResponse[];
  user_id: number;
  selectClientSearch: number = 0;
  selectRoleSearch: number = 0;

  @ViewChild("userNameSearch") userNameSearch: ElementRef
  @ViewChild("clientSearch") clientSearch: ElementRef

  userListFilter: IUserResponse[];

  constructor(private renderer: Renderer2,
    private builder: UntypedFormBuilder,
    private userAdministrationService: UserAdministrationService,
    private securityService: LoginService) { }

  async ngOnInit(): Promise<void> {

    
 const userName = JSON.parse(localStorage.getItem('ud'))[1].value
 const guid = JSON.parse(localStorage.getItem('guidSession'))
 const response = await this.securityService.login(userName,guid).toPromise()

    this.LoadFilters()
    this.configForm()
  }

  LoadFilters() {
    this.userAdministrationService.LoadFilters().subscribe((response) => {
      this.clientList = response.clients
      this.plantList = response.sites
      this.roleList = response.roles
      this.roleListFilterSearch = this.roleList.filter(p => p.businessSiteId === this.plantList[0].id)
      this.roleListFilterEdit = this.roleListFilterSearch
      this.userList = response.userClients
      this.userListFilter = this.userList
      this.setRols()
    })
  }

  plantInsertChange(plant: any){
    this.roleListFilterInsert = this.roleList.filter(p => p.businessSiteId === Number(plant))
  }

  configForm() {
    this.UserCatalog = this.builder.group({
      clientSelectInsert: [null, [Validators.required]],
      plantSelectInsert: ['', [Validators.required]],
      roleSelectInsert: ['', [Validators.required]],
      userNameInsert: [this.user_name]
    })
    this.UserRole = this.builder.group({
      clientSelectInsertRole: [''],
      plantSelectInsertRole: [''],
      roleSelectInsertRole: [''],
      userNameInsertRole: [this.user_name]
    })
  }

  changePlantSearch(plant: string) {
    this.roleListFilterSearch = this.roleList.filter(p => p.businessSiteId === Number(plant))
  }

  changePlantEdit(plant: string) {
    this.roleListFilterEdit = this.roleList.filter(p => p.businessSiteId === Number(plant))
  }

  AddUserRole(values: any) {
    const userRole = new UserRoleDto()
    userRole.roleId = values.roleSelectInsertRole
    userRole.userId = this.user_id
    this.userAdministrationService.InsertUserRol(userRole).subscribe((r) => {
      document.getElementById('resolution').style.display = 'block'
      setTimeout(() => {
        document.getElementById('resolution').style.display = 'none'
      }, 3000)
    })
  }

  InsertUser(values: any) {
    const user = new UserRoleDetailDto()
    const userClient = new UserClientDto()
    const userRole = new UserRoleDto()
    userClient.clientId = values.clientSelectInsert
    userClient.username = values.userNameInsert
    userClient.clientId = values.clientSelectInsert
    userRole.roleId = values.roleSelectInsert
    user.userClientDto = userClient
    user.userRoleDto = userRole
    this.userAdministrationService.InsertUserDetail(user).subscribe((r) => {
      document.getElementById('resolution').style.display = 'block'
      setTimeout(() => {
        document.getElementById('resolution').style.display = 'none'
      }, 3000)
    })
  }

  Edit() {
    this.editUser = true
  }

  selectUser(user: IUserResponse) {
    this.zone1 = false
    this.zone2 = true
    this.user_name = user.username
    this.user_id = user.id
    this.editUser = false
    this.userAdministrationService.GetUserDetail(user.username).subscribe((response) => {
      this.userDetailList = response
    })
  }

  AddUser() {
    this.zone1 = false
    this.zone2 = false
    this.zone3 = true
  }

  CancelEdit() {
    this.zone1 = true
    this.zone2 = false
  }

  GoToSearch() {
    this.zone1 = true
    this.zone2 = false
    this.zone3 = false
  }

  setRols(): void {
    this.userList.map((user) => {
      user.rolname = this.setRolName(user)
      user.rolid = this.setRolId(user)
    })
  }

  setRolId(user: IUserResponse): number {
    let id: number
    this.clientList.forEach(_rol => {
      if (user.clientId === _rol.id) {
        id = _rol.id
      }
    });
    return id
  }

  setRolName(user: IUserResponse): string {
    let rol: string = ''
    this.clientList.forEach(_rol => {
      if (user.clientId === _rol.id) {
        rol = _rol.name
      }
    });
    return rol
  }

  DeleteUser(id: any) {
    const userRole = new UserRoleDto()
    userRole.roleId = id
    userRole.userId = this.user_id
    this.userAdministrationService.DeleteUserRol(userRole).subscribe((r) => {

    })
  }

  onChangeClientSearch(value: number) {
    this.selectClientSearch = value
  }

  onChangeRoleSearch(value: number) {
    this.selectRoleSearch = value
  }

  Search() {
    if (this.selectClientSearch == 0 && this.selectRoleSearch == 0) {
      this.userListFilter = this.userList.filter(client => client.username.includes(this.userNameSearch.nativeElement.value))
    } else {
      if (this.selectClientSearch == 0 && this.selectRoleSearch != 0) {
        this.userListFilter = this.userList.filter(client => client.rolid == this.selectRoleSearch && client.username.includes(this.userNameSearch.nativeElement.value))
      } else {
        this.searchConditional()
      }
    }
  }

  searchConditional(){
    if (this.selectClientSearch != 0 && this.selectRoleSearch == 0) {
      this.userListFilter = this.userList.filter(client => client.clientId == this.selectClientSearch && client.username.includes(this.userNameSearch.nativeElement.value))
              } else {
      if (this.selectClientSearch != 0 && this.selectRoleSearch != 0) {
        this.userListFilter = this.userList.filter(client => (client.clientId == this.selectClientSearch
          && client.rolid == this.selectRoleSearch) && client.username.includes(this.userNameSearch.nativeElement.value))  
      }
    }

  }
}

